// @flow
export const USER_SIGNUP_REQUEST_FETCH = 'USER_SIGNUP_REQUEST_FETCH'
export const USER_SIGNUP_REQUEST_SUCCESS = 'USER_SIGNUP_REQUEST_SUCCESS'
export const USER_SIGNUP_REQUEST_FAIL = 'USER_SIGNUP_REQUEST_FAIL'
